import { render, staticRenderFns } from "./DaySelector.vue?vue&type=template&id=f47c170e&scoped=true&lang=pug"
import script from "./DaySelector.vue?vue&type=script&lang=js"
export * from "./DaySelector.vue?vue&type=script&lang=js"
import style0 from "./DaySelector.vue?vue&type=style&index=0&id=f47c170e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47c170e",
  null
  
)

export default component.exports